import {inject} from "@angular/core";
import {CanActivateFn, RedirectCommand, Router} from "@angular/router";
import {CurrentService} from "@/app/api/current.service";
import {filter, map} from "rxjs";
import {Current} from "@models/sportexam";
import {Rights} from "@models/sportexam/rights";

export const guardByRight = (right: keyof Rights): CanActivateFn => () => {
    const router = inject(Router);
    const current = inject(CurrentService);

    return current.current
        .pipe(
            filter(Boolean),
            map((user: Current) => {
                    const res = user.data.rights.none[right];
                    if (!res) {
                        const loginPath = router.parseUrl("/access-denied");
                        return new RedirectCommand(loginPath, {
                            skipLocationChange: true,
                        });
                    }

                    return true;
                }
            )
        )
}
